module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/ornament-left-white.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/ornament-left-white.png
// module id = 1222
// module chunks = 0